import AppContext from "~/contexts/App"
import { useContext } from "react"

const useOpenErrorSnackbar = () => {
  const { openSnackBar } = useContext(AppContext)
  return (err, defaultMessage) => {
    const errorMessage = err?.response?.data?.error || undefined
    openSnackBar(
      errorMessage !== undefined
        ? {
            message: errorMessage,
          }
        : { message: defaultMessage },
    )
  }
}
export default useOpenErrorSnackbar
